import { useMutation } from '@tanstack/react-query'
import { authApi } from '../api/auth.api'

interface CheckUserParams {
    identifier: string
    identifier_type: 'email' | 'mobile'
}

export function useCheckUser() {
    return useMutation({
        mutationFn: ({ identifier, identifier_type }: CheckUserParams) =>
            authApi.checkUserExists(identifier, identifier_type),
    })
}
